import type { BatteryRebateSchedule } from "./types.js";

// Cheaper Home Batteries (SRES) rebate schedule for installs from 1 Jan 2026
// up to 30 Apr 2026 — the PRE-1-May-2026 (higher) deeming factor.
//
// This file exists to encode the deeming STEP-DOWN: from 1 May 2026 the STC
// deeming factor dropped from 8.4 to 6.8 STCs per usable kWh. A historical
// install dated in Jan–Apr 2026 must value against THIS schedule, not the
// current one — so it stays registered. Never mutate a shipped schedule; a new
// step gets a new dated file.
//
// VERIFICATION (figure ledger
//   docs/research/discovery/verification/home-battery-rebate-sizer-figures.md):
//   - Deeming factor 8.4 STCs/usable kWh applied Jan–Apr 2026 (ledger Fig 2,
//     CITED to CER — the value that the 1-May-2026 change stepped DOWN from).
//   - Capacity taper 100% / 60% / 15% across 0–14 / 14–28 / 28–50 usable kWh,
//     50 kWh discounted usable cap, 100 kWh nominal max (CER-primary, CITED).
//   - STC price floats (indicative; spot near the $40 ex-GST clearing-house cap).
export const rates_2026_01_01: BatteryRebateSchedule = {
  product: "SOLAR_BATTERY",
  scheduleKey: "2026-01-01",
  scheduleLabel: "Cheaper Home Batteries schedule from 1 January 2026 (8.4 STC/kWh)",
  effectiveFrom: "2026-01-01",
  effectiveTo: "2026-04-30",
  sources: {
    scheme: "https://www.energy.gov.au/rebates/cheaper-home-batteries-program",
    cerSolarBatteries: "https://cer.gov.au/schemes/small-scale-renewable-energy-scheme/solar-batteries",
    cerChange2026May:
      "https://cer.gov.au/news-and-media/news/2026/february/changes-to-rebate-solar-batteries-1-may",
    stcClearingHouse:
      "https://cer.gov.au/schemes/small-scale-renewable-energy-scheme/small-scale-technology-certificates/buy-and-sell-small-scale-technology-certificates",
  },
  sourcesVerifiedAt: "2026-06-22",
  // Higher pre-1-May-2026 deeming factor — the value the step-down reduced.
  stcDeemingFactor: 8.4,
  taper: [
    { fromKwh: 0, toKwh: 14, factor: 1.0 },
    { fromKwh: 14, toKwh: 28, factor: 0.6 },
    { fromKwh: 28, toKwh: 50, factor: 0.15 },
  ],
  minUsableKwh: 5,
  maxNominalKwh: 100,
  discountedUsableCapKwh: 50,
  // Indicative only — STC spot floats near the $40 cap. Conservative net-of-
  // -admin estimate; callers can override with a current figure.
  indicativeStcPriceAud: 37,
  stcClearingHouseCapAud: 40,
};
